export const BOOTH_STORAGE_KEY = 'booth_storage_key';
export const LOGGING_STORAGE_KEY = 'logging-queue';
export const WEBCAM_STORAGE_KEY = 'webcam_key';
export const MODULE_ID_STORAGE_KEY = 'booth_module_id';
export const ENABLE_MODULE_MASTER_STORAGE_KEY = 'enable_module_master';
export const IS_MULTIPLE_CAMERA_STORAGE_KEY = 'is_multiple_camera_key';

export const MM_TIME_ZONE = 'Asia/Ho_Chi_Minh';
export const MAX_LENGTH_COUPON = 12;
export const STRAIGHT_ANGLE = 180;
export const NUMER_WARNING_OUT_OF_PAPER = 50;
export const THEME_PREVIEW_OFFSET_LIVEVIEW = 40;
export const SLIDE_NEXT_IN_MILISECONDS = 10000;
export const THEME_SYNC_FILE_PREFIX = {
  FONT_SEPARATE: '_',
  IMAGE: '--sync-file',
  FONT: '--sync-font',
};
